import {
    TooltipDate,
    TooltipMetric,
    TooltipMetricLabel,
    TooltipMetricLabelWrapper,
    TooltipName,
} from '../../PopularityTimeSeries/tooltip-components';
import { css, useTheme } from 'styled-components';
import { timeFormat, timeParse } from 'd3-time-format';
import Stack from 'components/Stack';
import TooltipCard from './TooltipCard';
import { formatVolume } from 'utils/helpers';

const defaultFormatAndParseTime = (v) =>
    timeFormat('%b %Y')(timeParse('%Y-%m-%d')(v));

const PredictionColor = css`
    color: ${({ theme }) => theme.purple_1};
`;

function Tooltip({
    left,
    top,
    width = 170,
    height = 150,
    chartWidth,
    chartHeight,
    offset = 40,
    accessors,
    tooltipOpen,
    tooltipData,
    formatAndParseTime = defaultFormatAndParseTime,
    metricLabel = 'Search Volume',
}) {
    const theme = useTheme();
    if (!tooltipOpen) return null;

    return (
        <TooltipCard
            left={left}
            top={top}
            chartWidth={chartWidth}
            chartHeight={chartHeight}
            offset={offset}
            width={width}
            height={height}
        >
            <Stack $space="1rem">
                <div>
                    <TooltipDate>
                        {tooltipData?.datum
                            ? formatAndParseTime(
                                  accessors.xAccessor(tooltipData?.datum),
                              )
                            : null}
                    </TooltipDate>
                    <TooltipName>{tooltipData.name}</TooltipName>
                </div>
                <TooltipMetricLabelWrapper
                    $strokeColor={
                        accessors.predictionAccessor(tooltipData.datum)
                            ? theme.purple_1
                            : tooltipData.strokeColor
                    }
                >
                    <TooltipMetric>
                        {formatVolume(accessors.yAccessor(tooltipData?.datum))}
                    </TooltipMetric>
                    <TooltipMetricLabel>{metricLabel}</TooltipMetricLabel>
                </TooltipMetricLabelWrapper>
            </Stack>
        </TooltipCard>
    );
}

export default Tooltip;
